<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="m3.7 17.1-.7-.7L9.3 10l4 4 6-5.9H16v-1h5v5h-1V8.8l-6.7 6.7-4-4z"
      />
    </svg>
  </span>
</template>
